// extracted by mini-css-extract-plugin
export default {"performanceMonitor":"PerformanceMonitor_performanceMonitor__t-3Fb","slideIn":"PerformanceMonitor_slideIn__XOsY0","metric":"PerformanceMonitor_metric__SHhMe"};